import * as yup from "yup";
import { Language } from "../../language/English";
export const RegionValidation = () => {
    return yup.object().shape({
        url : yup.string().min(3).max(250).required().label(Language.URL),
        name : yup.string().min(3).max(250).required().label(Language.BUSINESS_TYPE_NAME),
    });
}